import { Component, OnInit } from '@angular/core';
import { FormlyType } from '../ga-formly.service';
import { ExtraFieldType } from '../extra-field-type';
import { GaFormlyUtil } from '../ga-formly.util';
import { TranslationService } from '../../translation/translation.service';

@Component({
  selector: 'formly-field-radio-button',
  template: `
		<div class="radio form-check">
			<label class="form-check-label-wrapper" [class.disabled]="to.disabled">
				<input class="form-check-input" type="radio" [name]="key" [ngClass]="classNames" [value]="to.option" [formControl]="formControl" [formlyAttributes]="field">
				<span class="form-check-label" [innerHTML]="formatLabel(to.label)"></span>
			</label>
		</div>
	`
})
export class FormlyFieldRadioButtonComponent extends ExtraFieldType implements OnInit {
  constructor(
    private translationService:TranslationService,
    private formlyUtil: GaFormlyUtil
  ) {
    super();
  }

  public ngOnInit():void {
    this.classNames = this.formlyUtil.createClassNames(FormlyType.RADIO_BUTTON, <string>this.key, this.to.label);

    // register listener
    this.listen();
  }

  public formatLabel(label:string):string {
    const formatFn:Function = this.formlyUtil.getFormatFn(this.to.format);
    return this.translationService.instant(formatFn(label));
  }
}